import React from 'react'

import { DefaultTopbar } from '../../core/components/TopbarVariations'

export const ProductPageScreen = () => {
  return <DefaultTopbar />
}
